module.exports = __webpack_public_path__ + "img/placec.a181a234.jpg";